import React, { useEffect, useId, useMemo } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const formatPercent = (value, total) => {
  if (!total) {
    return "0.00%";
  }

  return `${((value / total) * 100).toFixed(2)}%`;
};

export default function DonutChart({ activeCount = 0, inactiveCount = 0 }) {
  const chartId = useId().replace(/:/g, "");

  const chartValues = useMemo(() => {
    const active = Number(activeCount || 0);
    const inactive = Number(inactiveCount || 0);
    const total = active + inactive;

    return {
      active,
      inactive,
      total,
    };
  }, [activeCount, inactiveCount]);

  useEffect(() => {
    const root = am5.Root.new(chartId);
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        radius: am5.percent(98),
        innerRadius: am5.percent(52),
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "quantity",
        categoryField: "member",
      })
    );

    series.data.setAll([
      {
        member: "Active",
        quantity: chartValues.active,
      },
      {
        member: "Inactive",
        quantity: chartValues.inactive,
      },
    ]);

    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);
    series.slices.template.set("strokeOpacity", 0);
    series.slices.template.set(
      "fillGradient",
      am5.RadialGradient.new(root, {
        stops: [
          { brighten: -0.5 },
          { brighten: -0.8 },
          { brighten: -0.5 },
          { brighten: 0 },
          { brighten: -0.5 },
        ],
      })
    );

    series.appear(1000, 100);
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chartId, chartValues]);

  return (
    <div className="dashboard-mock-donut-3d">
      <div className="dashboard-mock-donut-canvas">
        <div id={chartId} style={{ width: "100%", height: "100%" }} />
      </div>
      <div className="dashboard-mock-donut-legend">
        <div className="dashboard-mock-donut-legend-row">
          <span className="dashboard-mock-donut-legend-label">
            <span className="dashboard-mock-donut-dot is-active" />
            Active
          </span>
          <strong>{formatPercent(chartValues.active, chartValues.total)}</strong>
        </div>
        <div className="dashboard-mock-donut-legend-row">
          <span className="dashboard-mock-donut-legend-label">
            <span className="dashboard-mock-donut-dot is-inactive" />
            Inactive
          </span>
          <strong>{formatPercent(chartValues.inactive, chartValues.total)}</strong>
        </div>
      </div>
    </div>
  );
}
